import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Main from 'pages/Main.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-free/css/all.css';
import { faArrowUp, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './assets/sass/index.scss';
import './assets/sass/updatedComponents/carousel.css';
import './assets/sass/updatedComponents/coverage.css';
import './assets/sass/updatedComponents/horizontalBarChart.css';
import './assets/sass/updatedComponents/widget.css';
import './assets/sass/updatedComponents/dropDown.css';
import './assets/sass/updatedComponents/donut.css';
import './assets/sass/updatedComponents/pageTabs.css';
import './assets/sass/updatedComponents/dynamicFilter.css';

library.add(faArrowUp, faAngleRight);

class App extends React.Component {
    render() {
        return (
            <div>
                <Route path="/app" component={Main} {...this.props} />
                <Route
                    exact
                    path="/"
                    render={(props) => {
                        return <Redirect to={{ pathname: '/app' }} />;
                    }}
                    {...this.props}
                />
            </div>
        );
    }
}

export default App;
